const ThunderIconCirlcle = ({
    width = 24,
    height = 24,
    style = {},
    className = "",
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={style}
            className={className}
        >
            <circle cx="12" cy="12" r="12" fill="url(#paint0_linear_arrow_icon)" />
            <path
                d="M7.5 19.667L10.8082 15.0446H7.9985L11.1254 10.6942H7.6813L12.3489 4.66699H16.2972L12.9381 8.42829L16.175 8.33769L12.1543 13.232H15.3399L7.5 19.667Z"
                fill={"white"}
            />

            <defs>
                <linearGradient
                    id="paint0_linear_arrow_icon"
                    x1="12"
                    y1="0"
                    x2="7.64634"
                    y2="25.315"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#EEA415" />
                    <stop offset="1" stopColor="#FFD25E" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default ThunderIconCirlcle;
